var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgKeyIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 9,
    viewBox: "0 0 16 9",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.2474 3.20079H8.68073C8.13406 1.64745 6.65406 0.534119 4.91406 0.534119C2.7074 0.534119 0.914062 2.32745 0.914062 4.53412C0.914062 6.74079 2.7074 8.53412 4.91406 8.53412C6.65406 8.53412 8.13406 7.42079 8.68073 5.86745H8.91406L10.2474 7.20079L11.5807 5.86745L12.9141 7.20079L15.5807 4.50745L14.2474 3.20079ZM4.91406 6.53412C3.81406 6.53412 2.91406 5.63412 2.91406 4.53412C2.91406 3.43412 3.81406 2.53412 4.91406 2.53412C6.01406 2.53412 6.91406 3.43412 6.91406 4.53412C6.91406 5.63412 6.01406 6.53412 4.91406 6.53412Z",
    fill: "#1F6BEB"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgKeyIcon);
export default __webpack_public_path__ + "static/media/KeyIcon.e133e724.svg";
export { ForwardRef as ReactComponent };